import styled from 'styled-components';

export const Viewport = styled.div`
  height: ${p => p.viewHeight}px;
  position: relative;
`;

export default Viewport;
